import React from 'react';

/**
 * Pure presentational direct-transfer steps list.
 *
 * Extracted from EventPage.renderDirectTransferSteps. Parent decides whether
 * to render this component (i.e. passes only when `hasDirectMethods()` is
 * true) so the component itself has no conditional guards beyond the memo
 * branching it already does.
 *
 * Props:
 *   event         — event object (uses .payment_links)
 *   displayPrice  — computed total (number) to render in step 2
 */
export default function DirectTransferSteps({ event, displayPrice }) {
  const hasMemo = (event?.payment_links || []).some(l => l.payment_method_type === 'direct' && l.suggested_memo);
  return (
    <div className="mb-5 p-4 border border-[#1A1A1A] rounded-sm bg-[#0A0A0A]" data-testid="payment-instructions">
      <div className="text-xs text-[#777] uppercase tracking-widest font-semibold mb-3">How to Pay</div>
      <ol className="space-y-2">
        <li className="flex items-start gap-3 text-sm">
          <span className="w-5 h-5 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">1</span>
          <span className="text-[#AFAFAF]">Open your banking or payment app</span>
        </li>
        <li className="flex items-start gap-3 text-sm">
          <span className="w-5 h-5 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">2</span>
          <span className="text-[#AFAFAF]">Send <strong className="text-[#EAE7E1]">${displayPrice.toFixed(2)}</strong> to the recipient below</span>
        </li>
        {hasMemo && (
          <li className="flex items-start gap-3 text-sm">
            <span className="w-5 h-5 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">3</span>
            <span className="text-[#AFAFAF]">Include the suggested memo in your payment</span>
          </li>
        )}
        <li className="flex items-start gap-3 text-sm">
          <span className="w-5 h-5 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">{hasMemo ? '4' : '3'}</span>
          <span className="text-[#AFAFAF]">Return here and confirm your payment</span>
        </li>
      </ol>
    </div>
  );
}
